<template>
  <nav class="navbar navbar-expand-lg">
    <b-row class="w-100 justify-content-between align-items-center" no-gutters>
      <div class="navbar-brand">
        <Subheader :subHeader="subHeader"></Subheader>
      </div>
      <b-row class="align-items-center justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <base-dropdown tag="li">
              <template slot="title">
                <span>{{ $t(`language.${$i18n.locale}`) }}</span>
                <b class="caret"></b>
              </template>
              <a
                v-for="(lang, i) in lang"
                :key="i"
                class="dropdown-item"
                href="#"
                @click="changeLanguage(lang)"
                >{{ $t(`language.${lang}`) }}</a
              >
            </base-dropdown>
          </li>
        </ul>
        <ProfileButton></ProfileButton>
      </b-row>
    </b-row>
  </nav>
</template>
<script>
import Subheader from "@/views/layout/subheader/Subheader";
import ProfileButton from "@/views/layout/subheader/ProfileButton";
import { uiHelper } from "@/core/utils";

export default {
  name: "TopNavbar",
  components: {
    Subheader,
    ProfileButton,
  },
  props: {
    subHeader: {},
  },
  data: () => ({
    lang: ["en", "cn"],
    isOpen: false,
  }),
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  created() {
    uiHelper.setLocalStorage("language", "en");
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      uiHelper.setLocalStorage("language", lang);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style></style>
